import React, { Component } from 'react';
import { connect } from 'react-redux';
import MainRegister from './components/MainRegister';
import ButtonBase from '../../components/Buttons/ButtonBase';
import { assertionStepSubmittedAction } from '../../store/modules/assertionStepsSubmitted';
import './SignUpAccountType.scss';

class SignUpAccountType extends Component {
  state = {
    url: '',
    accountType: '',
    disabled: true
  };

  getAccountType = (type, accountType) => {
    let url =
      accountType === 'lawyer'
        ? 'registro-abogados/datos-abogado'
        : 'registro-abogados/datos-despacho';
    this.setState({
      disabled: !type,
      accountType,
      url
    });
  };

  handleSubmit = () => {
    const { accountType, url } = this.state;
    const { submitStep, stepsSubmitted, history } = this.props;
    let steps = {
      ...stepsSubmitted,
      accountType: accountType
    };
    submitStep(steps).then(res => {
      history.push(`/${url}`);
    });
  };

  render() {
    const { disabled } = this.state;
    return (
      <>
        <MainRegister getAccountType={this.getAccountType} />

        <div className="horizontal-layout" style={{ marginTop: 80 }}>
          <ButtonBase
            type="submit"
            variant="primary"
            disabled={disabled}
            onClick={this.handleSubmit}
          >
            Continuar
          </ButtonBase>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  stepsSubmitted: state.stepsSubmitted
});

const mapDispatchToProps = dispatch => ({
  submitStep: steps => dispatch(assertionStepSubmittedAction(steps))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpAccountType);
